import React from 'react';
import Admin from '../Admin';

const AdminGuard = ({ userInfo, onBack }) => {
    const isStaff = userInfo && (userInfo.role === 'staff' || userInfo.role === 'admin');

    if (isStaff) {
        return <Admin onBack={onBack} userInfo={userInfo} />;
    } else {
        return (
            <div className="container" style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'60vh'}}>
                <div style={{fontSize:'40px', marginBottom:'10px'}}>🚫</div>
                <h2>アクセス権限がありません</h2>
                <p style={{color:'#666'}}>管理メニューは運営メンバーのみ利用可能です。</p>
                <button onClick={onBack} className="btn btn-primary" style={{marginTop:'20px'}}>ホームに戻る</button>
            </div>
        );
    }
};

export default AdminGuard;